import { useContext, useRef, useState } from "react";
// @ts-ignore
import { useQuery } from "react-query";

// components
import BookingBox from "components/ListingNew/ListingNormal/BookingBox";
import Faqs from "components/ListingNew/ListingNormal/Faqs";
import ListingAbout from "components/ListingNew/ListingNormal/ListingAbout";
import ListingAmenites from "components/ListingNew/ListingNormal/ListingAmenities";
import ListingMeals from "components/ListingNew/ListingNormal/ListingMeals";
import ListingNameAddress from "components/ListingNew/ListingNormal/ListingNameAddress";
import ListingReviews from "components/ListingNew/ListingNormal/ListingReviews";
import ListingRoomsAndBeds from "components/ListingNew/ListingNormal/ListingRoomsAndBeds";
import Spotlights from "components/ListingNew/ListingNormal/Spotlights";
import ReadMoreWrapper from "components/ReadMoreWrapper";
import TravelPartnerBanner from "components/TravelPartnerBanner";
import ListingRoomsAndBedsOld from "../ListingRoomsAndBedsOld";
import { ListingLocation } from "components/ListingNew/ListingNormal/ListingLocation";
import { ListingCouponUi } from "../ListingCouponUi";
import "./style.scss";

// context
import { ListingInterface } from "context/ListingData";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";

// helpers
import { axiosInstance, goAxiosInstance } from "helpers/axiosInstance";
import parseHTML from "helpers/parseHTML";
import { ListingHeadingReuseComp } from "components/ListingNew/ListingHeadingReuseComp";
import { NextDesc } from "./NextDesc";
import RealMemories from "../RealMemories";
import { ListingFeatured } from "../ListingFeatured";

import { ReactComponent as PhoneSvg } from "assets/phone.svg";
import { AskMeModal } from "components/Booking/AskHelp";
import { UserContext } from "store";
import Modal from "components/LoginAndRegister/Modal";
import { FinishPhoneSignup } from "components/LoginAndRegister/FinishPhoneSignup";
import HighlightElement from "components/HighLighter";
import ListingExperience from "../ListingExperience";
import clevertap from "clevertap-web-sdk";
import { useTheme } from "components/ListingNew/ListingTheme";

// style

interface PageProps {
	query?: any;
	setShowLoginPopup: React.Dispatch<React.SetStateAction<boolean>>;
	datesError: boolean;
	dates: {
		checkin: "" | Date | null;
		checkout: "" | Date | null;
	};
	setDates: React.Dispatch<
		React.SetStateAction<{
			checkin: "" | Date | null;
			checkout: "" | Date | null;
		}>
	>;
	blocked: string[];
	onCreateBooking: () => void;
	calculations?: any;
	calLoading: boolean;
	mutation: any;
	openSharePopup: () => void;
	spl: boolean;
	storedDates: object;
	sortArrVal: any;
	bestVal: any;
	newCalculations: any;
	newDates: any;
	prevCalculations: any;
	guestImg: any;
}

const ListingContent = ({
	query,
	setShowLoginPopup,
	datesError,
	dates,
	setDates,
	blocked,
	onCreateBooking,
	calculations = () => {},
	calLoading,
	mutation,
	openSharePopup,
	spl,
	storedDates,
	sortArrVal,
	bestVal,
	newCalculations,
	newDates,
	prevCalculations,
	guestImg,
}: PageProps) => {
	const {
		// @ts-ignore
		data,
		// @ts-ignore
		childrenData,
		// @ts-ignore
		adultsData,
		// @ts-ignore
		roomsData,
		// @ts-ignore
		infantsData,
	} = useContext(ListingInterface);
	const [showOffers, setShowOffers] = useState(true);
	const listingList = data?.data?.listing_list;
	const id = listingList.id;
	const isNext = false;

	const corporatePDFlink =
		data?.data?.sleeping_and_spotlist.spot_info?.corporate_pdf_link;

	const width = useMediaQuery();
	const breakpoint = 900;
	const isMobile = width < breakpoint;

	const newRoomData = useQuery(
		["roomsAndbeds"],
		() =>
			goAxiosInstance({
				method: "GET",
				url: `https://go.saffronstays.com/api/listing-rooms?id=${id}`,
			}),
		{
			retry: false,
		},
	);

	const reviewsData = useQuery(
		["reviews"],
		() =>
			goAxiosInstance({
				method: "GET",
				url: `https://go.saffronstays.com/api/listing-reviews?id=${id}`,
			}),
		{
			retry: false,
		},
	);

	const apiData = useQuery(["listing_featured"], () => {
		return axiosInstance({
			method: "GET",
			url: `/featured_homes/fetch?ID=${id}`,
		});
	});

	const featuredData = apiData?.data?.data?.data;
	const [open, setOpen] = useState(false);
	const [showPopUp, setShowPopUp] = useState(false);
	const {
		state: { currentUser },
	} = useContext(UserContext);

	const theme = useTheme();

	return (
		<div className="listing__inner-wrapper listing__details-wrapper">
			<div className="listing__details">
				{data?.data?.sleeping_and_spotlist?.spot_info?.red_tape && (
					<p
						className="red-tape"
						style={{
							color: theme?.baseTextColor,
							background: theme?.background,
						}}
					>
						✨ {data?.data?.sleeping_and_spotlist?.spot_info?.red_tape}
					</p>
				)}
				<TravelPartnerBanner />
				<ListingNameAddress
					setShowLoginPopup={setShowLoginPopup}
					openSharePopup={openSharePopup}
					calError={
						mutation.error ? mutation.error?.response?.data?.error : datesError
					}
					dates={dates}
					id={id}
					childrenData={childrenData}
					adultsData={adultsData}
					roomsData={roomsData}
					infantsData={infantsData}
					calculations={calculations}
				/>
				{isNext && <NextDesc />}
				{/* <ListingAbout /> */}
				<div
					style={{ ...theme?.borderBtn }}
					onClick={() => {
						window.dataLayer.push({
							event: "connect_with_host",
							FULL_NAME: currentUser.fullName,
							MOBILE_NUMBER: currentUser.mobile,
							EMAIL_ID: currentUser.email,
							LISTING_ID: listingList?.id,
							FROM_DATE:
								Object.keys(calculations).length > 0
									? calculations.FROM_DATE
									: "NA",
							TO_DATE:
								Object.keys(calculations).length > 0
									? calculations.TO_DATE
									: "NA",
							NO_OF_GUESTS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_GUESTS
									: listingList?.max_capacity,
							NO_OF_ROOMS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_ROOMS
									: listingList?.num_similar_rooms,
							TOTAL_AMOUNT_WITH_SERVICE:
								Object.keys(calculations).length > 0
									? calculations.TOTAL_AMOUNT_WITH_SERVICE
									: listingList?.per_night_charge,
						});

						clevertap.event.push("connect_with_host", {
							FULL_NAME: currentUser.fullName,
							MOBILE_NUMBER: currentUser.mobile,
							EMAIL_ID: currentUser.email,
							LISTING_ID: listingList?.id,
							FROM_DATE:
								Object.keys(calculations).length > 0
									? calculations.FROM_DATE
									: "NA",
							TO_DATE:
								Object.keys(calculations).length > 0
									? calculations.TO_DATE
									: "NA",
							NO_OF_GUESTS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_GUESTS
									: listingList?.max_capacity,
							NO_OF_ROOMS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_ROOMS
									: listingList?.num_similar_rooms,
							TOTAL_AMOUNT_WITH_SERVICE:
								Object.keys(calculations).length > 0
									? calculations.TOTAL_AMOUNT_WITH_SERVICE
									: listingList?.per_night_charge,
						});
						setOpen(true);
					}}
					className="connect-btn"
				>
					Connect with Host
				</div>
				<Modal
					shouldShow={showPopUp}
					onRequestClose={() => {
						setShowPopUp(false);
					}}
				>
					<FinishPhoneSignup
						userUUID={localStorage.getItem("uuid")}
						redirect={() => window.location.reload()}
						onRequestClose={() => {
							setShowPopUp(false);
						}}
						userName={undefined}
						userEmail={undefined}
						userMobileNumber={undefined}
					/>
				</Modal>
				{open && (
					<AskMeModal
						open={open}
						setOpen={setOpen}
						data={{
							theme: theme,
							LISTING_ID: listingList?.id,
							FROM_DATE:
								Object.keys(calculations).length > 0
									? calculations.FROM_DATE
									: "NA",
							TO_DATE:
								Object.keys(calculations).length > 0
									? calculations.TO_DATE
									: "NA",
							NO_OF_GUESTS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_GUESTS
									: listingList?.max_capacity,
							NO_OF_ROOMS:
								Object.keys(calculations).length > 0
									? calculations.NO_OF_ROOMS
									: listingList?.num_similar_rooms,
							TOTAL_AMOUNT_WITH_SERVICE:
								Object.keys(calculations).length > 0
									? calculations.TOTAL_AMOUNT_WITH_SERVICE
									: listingList?.per_night_charge,
							isListing: true,
						}}
					/>
				)}
				<ListingHeadingReuseComp
					heading={"About Home"}
					comp={
						// @ts-ignore
						<ListingAbout
							color="#666"
							content={
								<ReadMoreWrapper numWords={50}>
									{parseHTML(
										`${
											(listingList?.TYPE_FLAG !== "EV"
												? listingList.about_villa
												: listingList.about_villa?.replace(
														"</ul>",
														`<li>We encourage you to book all rooms within the property for better experience. Still in case you wish to book limited number of rooms, please contact us <a href='tel:08069160000'>08069160000</a> or <a href='mailto:book@saffronstays.com'>book@saffronstays.com</a>.</li></ul>`,
												  )) +
											(corporatePDFlink
												? `<br><p><strong>Exploring options for a Corporate Offsite or planning a getaway for a large group? Discover our wide range of offerings tailored to ensure a memorable stay, click on <a href="https://ik.imagekit.io/5tgxhsqev/saffronstays-media/${corporatePDFlink}" target="_blank" rel="noopener noreferrer">Guide for a Corporate Offsite</a>.</strong></p>`
												: "")
										} ${
											listingList?.share_scheme === "PARTNER" ? (
												<ul>
													<li>Partner Home: Yes</li>
												</ul>
											) : (
												""
											)
										}`,
									)}
								</ReadMoreWrapper>
							}
						/>
					}
				/>
				<ListingHeadingReuseComp
					heading={"Amenities"}
					comp={
						<ListingAmenites
							color="#666"
							listingamenities={data?.data.amenities_type_list}
							amenityList={data?.data.amenities_list}
							notPresent={data?.data.not_amenities_list}
						/>
					}
				/>
				{data?.data?.sleeping_and_spotlist?.spot_info?.backstory ? (
					<ListingHeadingReuseComp
						heading={"Backstory"}
						comp={
							<div
								className="about__content__container"
								style={{
									marginLeft: "17px",
									color: theme?.baseTextColor,
								}}
							>
								<ReadMoreWrapper numWords={50}>
									{parseHTML(
										data?.data?.sleeping_and_spotlist?.spot_info?.backstory,
									)}
								</ReadMoreWrapper>
							</div>
						}
					/>
				) : null}
				<ListingHeadingReuseComp
					heading={"Meals"}
					comp={
						<ListingMeals
							color="#666"
							content={listingList?.meal_preference}
							isDiscount={listingList?.is_meal_five}
							veg={true}
							nonVeg={
								Object.keys(data.data.suitables_list).includes("73") ||
								Object.keys(data.data.suitables_list).includes("74")
							}
							menuLink={listingList?.meal_menu_url}
							listingList={listingList}
						/>
					}
				/>
				<ListingExperience listingData={data} />
				{guestImg?.length !== 0 && (
					<ListingHeadingReuseComp
						heading={"Real Moments"}
						comp={<RealMemories guestImages={guestImg} data={data?.data} />}
					/>
				)}
				<ListingHeadingReuseComp
					heading={"Location"}
					comp={<ListingLocation metaData={data?.meta} />}
				/>
				{data?.data?.sleeping_and_spotlist?.spot_images ? (
					<ListingHeadingReuseComp
						heading={"Spotlight"}
						comp={
							<Spotlights
								data={data?.data?.sleeping_and_spotlist?.spot_images}
								theme={theme}
							/>
						}
					/>
				) : null}

				{reviewsData?.data?.data?.data.length > 0 ||
				data.data.sleeping_and_spotlist?.spot_info?.elfsight_reviews_widget ? (
					<>
						<ListingHeadingReuseComp
							heading={"Reviews"}
							comp={
								<ListingReviews
									color="#666"
									data={data}
									isMobile={isMobile}
									reviewsData={reviewsData?.data?.data?.data}
									ratingData={data?.data?.rating_obj}
								/>
							}
						/>
					</>
				) : null}

				<ListingHeadingReuseComp
					heading={"Rooms & Beds"}
					comp={
						<>
							{newRoomData.data?.data?.data?.length !== 0 ? (
								<ListingRoomsAndBeds newRoomData={newRoomData} />
							) : (
								<ListingRoomsAndBedsOld
									roomsData={
										data?.data?.sleeping_and_spotlist?.sleeping_arrangment
									}
									numBedrooms={listingList?.num_similar_rooms}
									numSleeps={listingList?.max_capacity}
								/>
							)}
						</>
					}
				/>

				{featuredData?.length > 0 && <ListingFeatured data={featuredData} />}
				<HighlightElement targetId="FAQs" theme={theme}>
					<ListingHeadingReuseComp
						heading={"FAQs"}
						comp={<Faqs faqData={data?.data?.questions_list} />}
					/>
				</HighlightElement>
			</div>
			{!isMobile && (
				<BookingBox
					id={id}
					dates={dates}
					setDates={setDates}
					mealRequired={listingList?.meal_required === "1"}
					discount={
						listingList?.discount_7_days
							? listingList?.discount_7_days
							: listingList?.discount_28_days
					}
					pricePerNight={listingList?.per_night_charge}
					rating={data?.data?.rating_obj.rating_val}
					review={data?.data?.rating_obj.review}
					calculations={calculations}
					onCreateBooking={onCreateBooking}
					calLoading={calLoading}
					calError={
						mutation.error ? mutation.error?.response?.data?.error : datesError
					}
					blocked={blocked}
					spl={spl}
					sameDay={listingList?.same_day_booking}
					storedDates={storedDates}
					sortArrVal={sortArrVal}
					bestVal={bestVal}
					newCalculations={newCalculations}
					newDates={newDates}
					dis={listingList.priceWithoutgenDis}
					prevCalculations={prevCalculations}
				/>
			)}
		</div>
	);
};

export default ListingContent;
